import { Box, Container, Typography, styled } from '@mui/material'
import { Search } from '../scenes'
import { translate, parameter } from '../utils/resources'
import { resource } from '../utils/utilities'
import DEFAULT from '../config/default'

const PageIndex = () => {
    return (
        <Center>
            <Container maxWidth="sm">
                { DEFAULT.api.countryCode !== 'CH' && (
                    <Header>
                        <img className="img-fluid" src={resource('images/logo.svg')} alt="Natura" style={{ width: parameter("index.logo.width") }}/>
                    </Header>
                )}
                <Search reCaptchaEnabled />
                <Footer>
                    <Typography color="primary" align="center" variant="h6" component="h1" lineHeight="1.2" fontWeight={400}>
                        {translate('index.search.text')}
                    </Typography>
                </Footer>
            </Container>
        </Center>
    )
}

const Center = styled(Box)(({ theme }) => ({
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
}))

const Header = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 48
}))

const Footer = styled(Box)(({ theme }) => ({
    marginTop: 48
}))

export default PageIndex
